import React, { useContext, useEffect } from 'react'
import { useApolloClient } from '@apollo/client'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { AuthContext } from '../../Auth/AuthContext'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { types } from '../../Types/types'
import AvatarDefault from './../../Assets/Images/avatar-default.svg'
import NotificationNavLink from '../Notifications/NotificationNavLink'
import { objNameRoles as roles } from '../../const/constRoles'
import KnowledgeIcon from '../Knowledge/KnowledgeIcon'

export const Header = ({ avatar, toggleSidebar, setTypeSidebar }) => {
  const { dispatch, user } = useContext(AuthContext)

  const client = useApolloClient()
  const MySwal = withReactContent(Swal)

  const handleLogout = () => {
    MySwal.fire({
      icon: 'info',
      showCloseButton: true,
      showDenyButton: true,
      reverseButtons: true,
      title: 'Cerrar sesión',
      html: (
        <div className="message-container">¿Estás seguro de cerrar sesión?</div>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      confirmButtonText: 'Cerrar sesión',
      denyButtonText: 'Cancelar',
      focusDeny: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          client.clearStore()
          sessionStorage.removeItem('user')
          sessionStorage.removeItem('requestPath')
          localStorage.removeItem('token')
          localStorage.removeItem('configSys')
          localStorage.removeItem('platform')
          toastSweetAlert({
            mode: 'ok',
            message: 'Cerrar sesión con éxito',
          })
          setTimeout(() => {
            dispatch({
              type: types.logout,
            })
          }, 400)
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
      }
    })
  }

  const resizeHanlder = () => {
    const width = window.innerWidth
    if (width <= 991) {
      if (user?.role === roles.chofer_pipas) {
        return (document.getElementById('sidebarMain').className =
          'layout-fixed')
      }

      document.getElementById('sidebarMain').className =
        'sidebar-mini layout-fixed sidebar-closed sidebar-collapse'
    }
  }

  useEffect(() => {
    window.onresize = resizeHanlder
  }, [])

  return (
    <nav
      id="navbar"
      className="main-header navbar navbar-expand navbar-white navbar-light"
    >
      {/* <!-- Left navbar links --> */}
      {user?.role !== roles.chofer_pipas && (
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link menuBurguer"
              data-widget="pushmenu"
              href="/#"
              role="button"
            >
              <i className="fas fa-bars" style={{ fontSize: '23px' }}></i>
            </a>
          </li>
        </ul>
      )}

      {/* <!-- Right navbar links --> */}
      <ul className="navbar-nav ml-auto d-flex" style={{ gap: '10px' }}>
        {user?.role !== roles.chofer_pipas && (
          <NotificationNavLink
            toggleSidebar={toggleSidebar}
            setTypeSidebar={setTypeSidebar}
          />
        )}

        <KnowledgeIcon />
        
        {user?.role === roles.chofer_pipas && (
          <li
            className="d-flex justify-content-center align-items-center"
            style={{ width: '30px' }}
          >
            <Link to={'/'}>
              <i className="fas fa-home"></i>
            </Link>
          </li>
        )}

        <li
          className="d-flex justify-content-center align-items-center dropdown"
          style={{ width: '30px', cursor: 'pointer' }}
        >
          <button
            className="btn"
            data-widget="control-sidebar"
            data-slide="true"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="image container-pic d-flex justify-content-center align-items-center">
              <img
                src={avatar ?? AvatarDefault}
                className="img-circle"
                alt="User"
                style={{ width: '30px', height: '30px' }}
              />
            </div>
          </button>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{ left: 'inherit', right: 0 }}
          >
            <span className="dropdown-header m-0 p-0">
              {user?.name ?? 'User'}
            </span>
            <div className="dropdown-divider" />
            <Link to={'/profile'} className="dropdown-item text-center">
              Ver perfil
            </Link>
            <span
              className="dropdown-header m-0 p-0 logout-option"
              onClick={() => handleLogout()}
            >
              Salir
            </span>
          </div>
        </li>

        {/* 
        <li
          className="d-flex justify-content-center align-items-center mr-2"
          style={{ width: '30px' }}
          onClick={() => handleLogout()}
        >
          <a
            data-widget="control-sidebar"
            data-slide="true"
            href="/#"
            role="button"
          >
            <i className="fas fa-power-off"></i>
          </a>
        </li> */}
      </ul>
    </nav>
  )
}
export default Header
